import React, { useState } from 'react';
import { buscarCliente } from '../api/apiConfig';

const BuscadorClientes = () => {
  const [rut, setRut] = useState('');
  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!rut.trim()) {
      setError('Por favor ingrese un RUT');
      return;
    }

    setLoading(true);
    setError('');
    setCliente(null);

    try {
      const response = await buscarCliente(rut);
      console.log('Response from API:', response);
      
      // La API retorna directamente el array de datos
      if (Array.isArray(response) && response.length > 0) {
        setCliente(response[0]);
      } else {
        setError('Cliente no encontrado');
      }
    } catch (err) {
      console.error('Error searching client:', err);
      setError('Error al conectar con el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-baseline gap-4 mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Buscador de Clientes</h1>
      </div>

      <div className="seccion-datos">
        <form onSubmit={handleSearch} className="mb-6">
          <div className="flex gap-4 items-end">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                RUT del Cliente
              </label>
              <input
                type="text"
                value={rut}
                onChange={(e) => setRut(e.target.value)}
                placeholder="123456789-K"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? 'Buscando...' : 'Buscar'}
            </button>
          </div>
        </form>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        {cliente && (
          <div className="bg-white border border-gray-200 rounded-lg p-6">
            <h3 className="text-lg font-semibold mb-4">Información del Cliente</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-600">RUT</label>
                <p className="text-gray-900 font-medium">{cliente.RUT_CLI}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Cliente</label>
                <p className="text-gray-900 font-medium">{cliente.CLIENTE}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Ejecutivo</label>
                <p className="text-gray-900 font-medium">{cliente.EJECUTIVO}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BuscadorClientes;